import { render, staticRenderFns } from "./acc_labels.vue?vue&type=template&id=20919748&scoped=true&lang=html"
import script from "./acc_labels.vue?vue&type=script&lang=js"
export * from "./acc_labels.vue?vue&type=script&lang=js"
import style0 from "./acc_labels.vue?vue&type=style&index=0&id=20919748&prod&lang=css"
import style1 from "./acc_labels.vue?vue&type=style&index=1&id=20919748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20919748",
  null
  
)

export default component.exports